<template lang="pug">
.header__banner
  a.header__banner-wrapper.header__banner-wrapper--magnit(v-show="activeIndex === 2" href="https://redirect.appmetrica.yandex.com/serve/1182712044751741853" target="_blank" rel="noopener noreferrer")
    img.header__banner-fullimage(src="~@/assets/img/header/banner/magnit/banner.png" alt="Выигрывайте спорткар от Gorilla и Анара")
  .header__banner-wrapper.header__banner-wrapper--market(v-show="activeIndex === 3")
    img.header__banner-fullimage(src="~@/assets/img/header/banner/market/banner.png" alt="Новинка! Спортивное питание от Gorilla на маркетплейсах")
    a.header__banner-market-link.header__banner-market-link--wb(:href="wbUrl" target="_blank" rel="noopener noreferrer" aria-label="Купить на Wildberries")
    a.header__banner-market-link.header__banner-market-link--ozon(:href="ozonUrl" target="_blank" rel="noopener noreferrer" aria-label="Купить на OZON")
  a.header__banner-wrapper.header__banner-wrapper--mlbb(v-show="activeIndex === 1" href="https://gorillamlbb.ru" target="_blank" rel="noopener noreferrer")
    .header__banner-content
      .header__banner-content-title {{ $t('header.banner-mlbb.title') }}
        div {{ $t('header.banner-mlbb.title_accent') }}
      .header__banner-content-list
        img(src="~@/assets/img/header/banner/mlbb/banner-list.png")
    .header__banner-accent
      img(src="~@/assets/img/header/banner/mlbb/bg-banner-accent.png")
    .header__banner-image
      img(src="~@/assets/img/header/banner/mlbb/banner-product.png")
  //- Баннер «мармеладки» временно отключён — не удалять, при необходимости раскомментировать (и вернуть index 0 в ротацию ниже)
    .header__banner-wrapper.header__banner-wrapper--marmelade(v-show="activeIndex === 0" v-tap="showModal")
      .header__banner-content
        .header__banner-content-title {{ $t('header.banner.title') }}
          span {{ $t('header.banner.title_accent') }}
        .header__banner-content-text {{ $t('header.banner.text') }}
        .header__banner-marketplace
          img(src="~@/assets/img/header/banner/marmelade/wb.png" alt="wb")
          img(src="~@/assets/img/header/banner/marmelade/ozon.png" alt="ozon")
      .header__banner-image
        img(src="~@/assets/img/header/banner/marmelade/banner-product-mini.png")
</template>

<script>

export default {
  name: 'HeaderBanner',
  data () {
    return {
      // Market banner (3) shows first, then the rotation cycles.
      activeIndex: 3,
      timer: null,
      wbUrl: 'https://www.wildberries.ru/seller/250051432?sort=popular&page=1&fbrand=312295560',
      ozonUrl: 'https://www.ozon.ru/seller/fahrenheit-nutrition-formula/brand/gorilla-ultimate-102077913/'
    }
  },
  mounted () {
    this.startRotation()
  },
  beforeDestroy () {
    this.stopRotation()
  },
  computed: {
    isRuLang: vm => vm.$i18n.locale === 'ru'
  },
  methods: {
    showModal () {
      this.$modal.show('ModalBanner')
    },
    startRotation () {
      // Cycle market (3) -> mlbb (1) -> magnit (2) -> market (3) ..., one banner per 15s.
      this.timer = this.isRuLang ? setInterval(() => {
        this.activeIndex = this.activeIndex === 2 ? 3 : this.activeIndex === 3 ? 1 : 2
      }, 15000) : null
    },
    stopRotation () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>
